import React from 'react';
import './App.css';
import  MqttClient from './mqtt/MqttClient';
import { initiateDeviceAuthFlow, getAccessToken, refreshAccessToken } from './mqtt/OAuth2DeviceAuth';
//import { publishMqttMessage } from './ble/MqttClient';

// ***********************************************************************************************************
// Setup requirements: npm install mqtt
// ***********************************************************************************************************

function App() {
    //const tokenRefresh = '';
    //let deviceCode = ''
    //let userCode = ''
    //let verificationUri = ''
    //let verificationUriComplete = ''

    async function authorizeDevice() {
        try {
            const objResponse1 = await initiateDeviceAuthFlow('emqx-dev', 'openid offline_access');
            if (objResponse1) {
                //deviceCode = objResponse1.device_code;
                //userCode = objResponse1.user_code;
                //verificationUri = objResponse1.verification_uri;
                //verificationUriComplete = objResponse1.verification_uri_complete;
                console.log(objResponse1);
            }

            // Open browser window for user verification
            window.open(objResponse1.verification_uri_complete, '_blank');

            // Start checking for verification result and auth token 
            const objResponse2 = await getAccessToken('urn:ietf:params:oauth:grant-type:device_code', objResponse1.device_code, 'emqx-dev');
            if (objResponse2) {
                localStorage.setItem('accessToken', objResponse2.access_token);
                localStorage.setItem('refreshToken', objResponse2.refresh_token);            
                console.log(objResponse2);
            }

        } catch (err: any) {
            console.log('authorizeDevice Error: ', err.message);
        } finally {
        }      
    }

    async function refreshToken() {
        try {
            const objResponse1 = await refreshAccessToken('refresh_token', 'emqx-dev', localStorage.getItem('refreshToken')||'');
            if (objResponse1) {
                localStorage.setItem('accessToken', objResponse1.access_token);
                localStorage.setItem('refreshToken', objResponse1.refresh_token);            
                console.log(objResponse1);
            }

        } catch (err: any) {
            console.log('refreshToken Error: ', err.message);
        } finally {
        }      
    }

    /*
    function publishMessage() {
       try {
            publishMqttMessage("sentinel/joblog", "Hello from React TypeScript!", 'sa_broker', localStorage.getItem('accessToken')||'', false);
 
        } catch (err: any) {
            console.log('publishMessage Error: ', err.message);
        } finally {
        }      

    }
    */

    //async function main() {
        //const result1 = await fetchData1();
        //console.log(result1);

        //const result2 = await fetchData2(123);
        //console.log(result2);

        //const success = await processData("Some input string");
        //console.log(`Processing successful: ${success}`);


        //const result4 = await getAccessToken('urn:ietf:params:oauth:grant-type:device_code', deviceCode, 'emqx-dev');
        //if (result4)
        //    console.log(result4);

        //const result5 = await refreshAccessToken('refresh_token', 'emqx-dev', tokenRefresh);
        //if (result5)
        //    console.log(result5);
    //}

    //main();



    return (
         <div className="App">
           <h2>React MQTT Publisher/OAuth2 Test</h2>

            <MqttClient 
                topic="sentinel/joblog/test.log"
                message="Started up and sent a message."
                mqttUID = 'sa_broker'
                mqttPWD = {localStorage.getItem('accessToken') || ''}
            />
            <div style={{ marginTop: "10px" }}>
                <button onClick={authorizeDevice}>Authorize Device</button>
            </div>
            <div style={{ marginTop: "10px" }}>
                <button onClick={refreshToken}>Refresh Token</button>
            </div>
        </div>
    );

    // ***********************************************************************************************************
    // To use Oauth2DeviceAuthOrig,tsx
    //    -  Uncomment below and add back into return section  and update the import above
    // ***********************************************************************************************************
    //        <MqttClient 
    //            topic="gwe/topic/test"
    //            message="Hello from React TypeScript!"
    //            mqttUID = 'sa_broker'
    //            mqttPWD = {localStorage.getItem('accessToken') || ''}
    //        />

    //        <div style={{ marginTop: "10px" }}>
    //            <button onClick={publishMessage}>Publish Message</button>
    //        </div>

}

export default App;